import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { isJobAdmin } from '../../../config/jobAdmins';
import styles from './WaitlistGate.module.css';

interface JobAdminGateProps {
  children: React.ReactNode;
}

/**
 * Second gate for /jobs, applied after WaitlistGate has established that the
 * user is signed in. The backend enforces the same rule independently.
 */
export const JobAdminGate: React.FC<JobAdminGateProps> = ({ children }) => {
  const { userEmail } = useAuth();

  if (isJobAdmin(userEmail)) return <>{children}</>;

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>Not available</h2>
        <p className={styles.subtitle}>
          The job monitor is restricted to the platform operators.
        </p>
        <a href="/chat" className={styles.homeLink}>
          Go to chat
        </a>
      </div>
    </div>
  );
};
